import { z } from 'zod';

import { getCurrentIntl } from '~/i18n/intl/intl';
const intl = getCurrentIntl();

const emptyObjectSchema = z.object({}).strict();
export const isEmptyObject = (object: object): boolean => {
  const result = emptyObjectSchema.safeParse(object);
  return result.success;
};

const anyObjectSchema = z.object({}).passthrough();
export const isAnyObject = (maybeObject: unknown): maybeObject is object => {
  const result = anyObjectSchema.safeParse(maybeObject);
  return result.success;
};

const literalSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
type Literal = z.infer<typeof literalSchema>;

type Json = Literal | { [key: string]: Json } | Json[];
const jsonSchema: z.ZodType<Json> = z.lazy(() =>
  z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]),
);

const json = () => jsonSchema;

export const stringToJSONSchema = z
  .string()
  .transform((str, ctx): z.infer<ReturnType<typeof json>> => {
    try {
      return JSON.parse(str);
    } catch (e) {
      ctx.addIssue({ code: 'custom', message: 'Invalid JSON' });
      return z.NEVER;
    }
  });

export const passwordSchema = z
  .string()
  .trim()
  .max(255)
  .min(
    8,
    intl.formatMessage({
      defaultMessage:
        'This password is too short. It must contain at least 8 characters.',
    }),
  )
  .regex(
    /\d/,
    intl.formatMessage({
      defaultMessage:
        'This password is too short. It must contain at least 8 characters.',
    }),
  )
  .regex(
    /[A-Z]/,
    intl.formatMessage({
      defaultMessage: 'This password must contain at least 1 uppercase letter.',
    }),
  )
  .regex(
    /[a-z]/,
    intl.formatMessage({
      defaultMessage: 'This password must contain at least 1 lowercase letter.',
    }),
  )
  .regex(
    /[!@#$%^&*(),.?":{}|<>]/,
    intl.formatMessage({
      defaultMessage: 'This password must contain at least 1 symbol.',
    }),
  );
